import React, { Component } from 'react';

class Contact extends Component {
  constructor(props) {
    super(props);

  }

  render() {
    
    return (
      <div className="contact">
		    <div className="content cf">
		        <h1>Contact</h1>

		        <div id="DOContact">
			                    <form method="post" id="contact_form" action="contact">
		                <div className="form-section">
		                    <div className="field">
		                        <div className="default" >
		                            <input type="text" size="40" value="" name="first_name" id="contact_f_name" className="default" placeholder="First Name" />
		                        </div>
		                    </div>
		                    <div className="field right">
		                        <div className="default" >
		                            <input type="text" size="40" value="" name="last_name" id="contact_l_name" className="default" placeholder="Last Name" />
		                        </div>
		                    </div>
		                    <div className="field">
		                        <div className="default" >
		                            <input type="text" size="40" value="" name="email" id="contact_email" className="default" placeholder="Email Address" />
		                        </div>
		                    </div>
		                    <div className="field right">
		                        <div className="default" >
		                            <input type="text" size="40" value="" name="phone" id="contact_phone" className="default" placeholder="Mobile Number" />
		                        </div>
		                    </div>
		                    <div className="field text">
		                        <div className="text" >
		                            <textarea rows="10" cols="30" name="comments" id="contact_comments" className="text" placeholder="Comments or Questions" ></textarea>
		                        </div>
		                    </div>
		                </div>

		               
		                <div>
		                    <input type="submit" value="Submit"  id="submit"/>
		                </div>
		            </form>
		                    </div>
		    </div>
		</div>

    );
  }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/contact.jsx